export const x = {
  name: "x" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m3.044 3 6.95 9.928L3 21h1.574l6.123-7.067L15.644 21H21l-7.34-10.486L20.168 3h-1.574l-5.639 6.509L8.4 3H3.044Zm2.315 1.239h2.46L18.685 19.76h-2.46L5.357 4.24Z"/></svg>`,
  keywords: ["x"],
  category: "social" as const,
};
